/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

function CurrentDefenses(props) {
  const { handleChange } = props;
  return (
    <div className=" flex flex-col items-center w-full">
      <form className=" w-full xl:px-24 md:px-4">
        <div className="flex flex-wrap mx-3 xl:mb-8 md:mb-6 mb-3">
          <div className="w-full px-3 lg:mb-6">
            <label
              htmlFor="CurrentDefenses"
              className="block font-medium text-sm text-gray-700"
            >
              Current Defenses
              <span className="text-red-500">*</span>
            </label>

            <div>
              <input
                className="mt-1 w-3/4 border-gray-400 focus:border-indigo-500 focus:ring-indigo-500 rounded-sm shadow-sm"
                type="text"
                placeholder="Enter Current Defense"
                onChange={handleChange}
              />
              <button className="mt-2 text-red-900 float-right bg-blue-400 rounded-md py-2 px-4" type="button">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CurrentDefenses;
CurrentDefenses.propTypes = {
  handleChange: PropTypes.func.isRequired,
};
